const badgeColors = {
    red: {
        bg: 'bg-red-100',
        text: 'text-red-700',
        hover: 'hover:bg-red-600/20',
        stroke: 'stroke-red-700/50',
        groupHover: 'group-hover:stroke-red-700/75'
    },
    green: {
        bg: 'bg-green-100',
        text: 'text-green-700',
        hover: 'hover:bg-green-600/20',
        stroke: 'stroke-green-700/50',
        groupHover: 'group-hover:stroke-green-700/75'
    },
    blue: {
        bg: 'bg-blue-100',
        text: 'text-blue-700',
        hover: 'hover:bg-blue-600/20',
        stroke: 'stroke-blue-700/50',
        groupHover: 'group-hover:stroke-blue-700/75'
    },
    yellow: {
        bg: 'bg-yellow-100',
        text: 'text-yellow-700',
        hover: 'hover:bg-yellow-600/20',
        stroke: 'stroke-yellow-700/50',
        groupHover: 'group-hover:stroke-yellow-700/75'
    },
    purple: {
        bg: 'bg-purple-100',
        text: 'text-purple-700',
        hover: 'hover:bg-purple-600/20',
        stroke: 'stroke-purple-700/50',
        groupHover: 'group-hover:stroke-purple-700/75'
    },
    orange: {
        bg: 'bg-orange-100',
        text: 'text-orange-700',
        hover: 'hover:bg-orange-600/20',
        stroke: 'stroke-orange-700/50',
        groupHover: 'group-hover:stroke-orange-700/75'
    },
    stone: {
        bg: 'bg-stone-100',
        text: 'text-stone-700',
        hover: 'hover:bg-stone-600/20',
        stroke: 'stroke-stone-700/50',
        groupHover: 'group-hover:stroke-stone-700/75'
    },
    gray: {
        bg: 'bg-gray-100',
        text: 'text-gray-700',
        hover: 'hover:bg-gray-600/20',
        stroke: 'stroke-gray-700/50',
        groupHover: 'group-hover:stroke-gray-700/75'
    }
}

export const badgeColorsChoices = [
    { id: 1, name: 'colors.red', color: 'red' },
    { id: 2, name: 'colors.green', color: 'green' },
    { id: 3, name: 'colors.blue', color: 'blue' },
    { id: 4, name: 'colors.yellow', color: 'yellow' },
    { id: 5, name: 'colors.purple', color: 'purple' },
    { id: 6, name: 'colors.orange', color: 'orange' },
    { id: 7, name: 'colors.gray', color: 'gray' }
];

export default function Badge({text, color, onClickRemove, withoutRemove = false, className, onClick}) {

    return (
        <span className={`inline-flex items-center gap-x-0.5 rounded-md ${badgeColors[color].bg} px-2 py-1 text-xs font-medium ${badgeColors[color].text} ${className}`} onClick={onClick}>
                   {text}
                   {!withoutRemove && <button onClick={onClickRemove} type="button" className={`group relative -mr-1 size-3.5 rounded-sm ${badgeColors[color].hover}`}>
                     <span className="sr-only">Remove</span>
                     <svg viewBox="0 0 14 14" className={`size-3.5 ${badgeColors[color].stroke} ${badgeColors[color].groupHover}`}>
                       <path d="M4 4l6 6m0-6l-6 6" />
                     </svg>
                     <span className="absolute -inset-1" />
                   </button>}
                 </span>
    )
}